(function($) {

	'use strict';

	let deferredPrompt;

	var ua			= window.navigator.userAgent;
	var isIOS		= !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
	var isWebkit	= !!ua.match(/WebKit/i);
	var isIOSSafari	= isIOS && isWebkit && !ua.match(/CriOS/i);
	var isFirefox	= typeof InstallTrigger !== 'undefined';

	var init = function() {
        setupListeners();
		initWorker();
	};

	var setupListeners = function() {
		if( 'onbeforeinstallprompt' in window ){
			window.addEventListener('beforeinstallprompt', (e) => {
				deferredPrompt = e;
				$('.mainMenu__webApp').on('click', (e) => {
					e.preventDefault();
					deferredPrompt.prompt();
					// Wait for the user to respond to the prompt
					deferredPrompt.userChoice.then((choiceResult) => {
						if (choiceResult.outcome === 'accepted') {
							// console.log('User accepted the A2HS prompt');
						} else {
							// console.log('User dismissed the A2HS prompt');
						}
						deferredPrompt = null;
					});
				});
			});
		} else {
			if(isIOS){
				if(isIOSSafari){
					// Popup safari IOS
					$('.mainMenu__webApp').on('click', (e) => {
						$('.popup#a2hs-safari').addClass('active');
					});
				} else {
					// Popup safari other browsers
					$('.mainMenu__webApp').on('click', (e) => {
						$('.popup#a2hs-ios').addClass('active');
					});
				}
			} else if(isFirefox){
				// Popup firefox
				$('.mainMenu__webApp').on('click', (e) => {
						$('.popup#a2hs-firefox').addClass('active');
					});
			}
		}
	};

	var initWorker = function(){
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker
				.register(window.location.origin + "/sw.js", { scope: '/' }) // Remplacé par le service worker de OneSignal, car il importe désormais sw.js 
				.then(() => { console.log('Service Worker Registered'); }).catch(function (e)
				{
				  console.error('Error during service worker registration:', e);
				});
		}
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);